export default __webpack_public_path__ + "static/media/step-2.f15c11b4.svg";